export default async function (logoutUrl: string) {
  const { keycloak } = useKeycloak();
  localStorage.removeItem('selectedFlorist');
  localStorage.removeItem('multiShop');

  if (typeof window !== 'undefined' && (window as any).WebEmarsysSdk) {
    const sdk = (window as any).WebEmarsysSdk;
    if (typeof sdk === 'function') {
      sdk('logout');
    } else if (sdk && typeof sdk.logout === 'function') {
      sdk.logout();
    }
  }

  try {
    await keycloak.logout({ redirectUri: logoutUrl });
  } catch (error) {
    console.error('--> log: logout error ', error);
  }
}
